export default {
  meta: {
    title: '一鸣 PDF 本地调试',
    parentPath: '/expandstore/chancepoint',
    breadcrumbs: ['机会点', 'PDF 本地调试'],
  },
};
